// extracted by mini-css-extract-plugin
module.exports = {"prev":"Previous_prev__nRln6","prev__txt":"Previous_prev__txt__GyDB7"};